<template>
   <div class="welcome-container">
      <div class="first-half">
         <img src="@/assets/images/one-five-blue-trademark.png" alt="one-five logo" class="logo">
         <p class="dsp"><span>Q</span>uartermaster</p>
      </div>
      <div class="second-half">
         <p>Please sign in to continue</p>
         <GoogleLogin />
      </div>
   </div>
</template>
<script setup lang="ts">
import GoogleLogin from "../components/GoogleLogin.vue";  
</script>
<style lang="scss" scoped>
   .welcome-container {
      min-height: 100vh;
      display: flex;
      .first-half, .second-half {
         display: flex;
         width: 50%;
         flex-direction: column;
         align-items: center;
         justify-content: center;
      }
      .first-half {
         background-color: $grey-medium;
      }
      .second-half{
         position: relative;
         background-color: $one-five-blue;
         &::after {
            content: "";
            background: url(@/assets/images/one-five-icon-white.png);
            opacity: 0.05;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            position: absolute;
            height: 100vh;
            background-repeat: no-repeat; 
            background-position: center;
            z-index: 1;
         }
         p {
            color: $grey-light;
            margin-bottom: 1rem;
            font-weight: 200;
            font-size: 1rem;
         }
      }
      .logo {
         width: 400px;
         margin-bottom: 50px;
      }

      .dsp {
         font-size: 3rem;
         font-weight: 200;
         color: $one-five-blue;
         text-transform: uppercase;
         text-align: center;
         letter-spacing: 3px;
         display: flex;
         align-items: center;
         span {
            font-weight: 300;
            font-size: 6rem;
         }
      }
   }
   
   
</style>

